import React from 'react';
import { GalleryImageWrapper, GalleryImage, GalleryThumb } from './style';
import { Box } from '@mui/material';
import { TourImageDetail } from '@/types/tourBooking';

interface NormalGalleryProps {
  images: TourImageDetail[];
  mainImgIdx: number;
  prevImgIdx: number | null;
  fade: 'gallery-fade-in' | 'gallery-fade-out';
  onThumbClick: (idx: number) => void;
  alt?: string;
}

const NormalGallery: React.FC<NormalGalleryProps> = ({ images, mainImgIdx, prevImgIdx, fade, onThumbClick, alt }) => {
  return (
    <>
      <GalleryImageWrapper style={{ marginBottom: 16 }}>
        {prevImgIdx !== null && (
          <GalleryImage
            src={images[prevImgIdx].url}
            alt={images[prevImgIdx].alt && images[prevImgIdx].alt !== '' ? images[prevImgIdx].alt : "prev"}
            className="gallery-fade-out"
          />
        )}
        <GalleryImage
          src={images[mainImgIdx].url}
          alt={images[mainImgIdx].alt && images[mainImgIdx].alt !== '' ? images[mainImgIdx].alt : (alt && alt !== '' ? alt : 'Gallery')}
          className={fade}
        />
      </GalleryImageWrapper>
      <Box display="flex" justifyContent="center" marginBottom={2} maxWidth="100%" sx={{ overflowX: 'auto', padding: '0 0 0 64px' }}>
        {images.map((img, idx) => (
          <GalleryThumb
            key={img.uid}
            src={img.url}
            alt={img.alt && img.alt !== '' ? img.alt : `thumb-${idx}`}
            onClick={() => onThumbClick(idx)}
            className={idx === mainImgIdx ? 'active' : ''}
          />
        ))}
      </Box>
    </>
  );
};

export default NormalGallery; 